/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".my-container[_ngcontent-%COMP%]{padding:1rem;overflow:auto;height:100%;flex-direction:column;background-color:#fff}@media (min-width:600px){.my-container[_ngcontent-%COMP%]{width:40%;margin:0 auto}}.my-container[_ngcontent-%COMP%]   .top-wrapper[_ngcontent-%COMP%]{padding:3%}.my-container[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]{padding-bottom:2rem}.my-container[_ngcontent-%COMP%]   .top[_ngcontent-%COMP%]   .welcome-back[_ngcontent-%COMP%]{font-size:1.6rem}"];
export { styles as styles };
